/* ============================================================
   SOLVEY · product header behaviours (4 PDP's)
   - Gallery dots (mobile) — alle 4 PDP's
   - Price+rating inline (re-parent) — alleen restore-probiotics
   - Clickable rating → scroll to reviews — alleen restore-probiotics
   - Quantity inline (CSS-only, marker for analytics) — alle 4 PDP's
   ============================================================ */
(function () {
  'use strict';
  if (window.__solveyProductHeaderInit) return;
  var DOTS_HANDLES = [
    'product-handle--restore-probiotics',
    'product-handle--urinary-tract-blend',
    'product-handle--carvacrol-complex-oregano-oil',
    'product-handle--boric-acid-600mg-vaginal-suppositories',
    'product-handle--vaginal-balance-bundle',
    'product-handle--total-reset-bundle',
    'product-handle--restore-probiotics-intimate-care-cream',
    'product-handle--clear-out-patches-with-salicylic-acid',
    'product-handle--intimate-care-cream',
    'product-handle--intimate-shave-bar',
    'product-handle--prepare-prenatal-pregnancy-supplement',
    'product-handle--vaginale-schimmelinfectie-zelftest'
  ];
  var IS_PROBIOTICS = document.body.classList.contains('product-handle--restore-probiotics');
  var IS_DOTS_PDP = DOTS_HANDLES.some(function (h) { return document.body.classList.contains(h); });
  if (!IS_DOTS_PDP) return;
  window.__solveyProductHeaderInit = true;

  var DEBOUNCE = 50;
  var MOBILE_MQ = window.matchMedia('(max-width: 749px)');

  function debounce(fn, ms) {
    var t; return function () {
      clearTimeout(t);
      var a = arguments, c = this;
      t = setTimeout(function(){ fn.apply(c, a); }, ms);
    };
  }

  /* ---------- 1. Gallery dots (mobile only) ---------- */
  function initGalleryDots() {
    var container = document.querySelector('.product__media-container');
    if (!container) return;
    var thumbs = container.querySelectorAll('.product-thumbnails__item-link');
    if (!thumbs.length) return;

    var existing = container.querySelector('.solvey-gallery-dots');

    // Idempotence: rebuild only if thumb-count changed (robust against variant placeholders)
    if (existing && existing.dataset.thumbCount === String(thumbs.length)) {
      var dotsNow = existing.querySelectorAll('.solvey-gallery-dots__dot');
      thumbs.forEach(function (t, i) {
        if (dotsNow[i]) dotsNow[i].setAttribute('aria-current', t.classList.contains('active') ? 'true' : 'false');
      });
      return;
    }

    if (existing) existing.remove();

    var dotsEl = document.createElement('ul');
    dotsEl.className = 'solvey-gallery-dots';
    dotsEl.setAttribute('data-solvey-gallery-dots', '');
    dotsEl.dataset.thumbCount = String(thumbs.length);
    dotsEl.setAttribute('aria-label', 'Product image pagination');

    thumbs.forEach(function (thumb, i) {
      var li = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'solvey-gallery-dots__dot';
      btn.setAttribute('aria-label', 'Show image ' + (i + 1));
      btn.setAttribute('aria-current', thumb.classList.contains('active') ? 'true' : 'false');
      btn.addEventListener('click', function () { thumb.click(); });
      li.appendChild(btn);
      dotsEl.appendChild(li);
    });

    var media = container.querySelector('.product__media');
    if (media && media.parentNode === container) {
      container.insertBefore(dotsEl, media.nextSibling);
    } else {
      container.appendChild(dotsEl);
    }
  }

  /* ---------- 1b. Gallery swipe (mobile only) ----------
     Foxify gallery hides non-active media-items via `.hidden` and provides
     no native touch handling. We bridge that by mapping a horizontal swipe
     on the visible image to a thumb-click (which already drives the gallery
     and updates dots/active-state via the existing MutationObserver). */
  function initGallerySwipe() {
    var media = document.querySelector('.product__media');
    if (!media || media.dataset.solveySwipe === '1') return;
    media.dataset.solveySwipe = '1';

    var MIN_DX = 40;       // px — minimum horizontal travel
    var DOMINANCE = 1.2;   // |dx| must exceed |dy| * DOMINANCE to count as horizontal

    var startX = 0, startY = 0, tracking = false;

    media.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { tracking = false; return; }
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });

    media.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      if (Math.abs(dx) < MIN_DX) return;
      if (Math.abs(dx) < Math.abs(dy) * DOMINANCE) return;

      var container = document.querySelector('.product__media-container');
      if (!container) return;
      var thumbs = container.querySelectorAll('.product-thumbnails__item-link');
      if (!thumbs.length) return;
      var idx = -1;
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains('active')) { idx = i; break; }
      }
      if (idx < 0) idx = 0;
      var next = dx < 0 ? idx + 1 : idx - 1;
      if (next < 0 || next >= thumbs.length) return;
      thumbs[next].click();
    }, { passive: true });
  }

  /* ---------- 2. Re-parent rating into price wrap ---------- */
  function initPriceRatingInline() {
    var inner = document.querySelector('.product__block--product-header-inner');
    if (!inner) return;
    var priceWrap = inner.querySelector('.product__price-and-ratings');
    var ratingWrap = inner.querySelector('.product__rating-below-price');
    if (!priceWrap || !ratingWrap) return;
    if (ratingWrap.parentNode === priceWrap) {
      inner.dataset.solveyHeaderInline = '1';
      return;
    }
    priceWrap.appendChild(ratingWrap);
    inner.dataset.solveyHeaderInline = '1';
  }

  /* ---------- 3. Clickable rating ---------- */
  function findReviewsTarget() {
    var heads = document.querySelectorAll('h2');
    for (var i = 0; i < heads.length; i++) {
      var t = heads[i].textContent.trim();
      if (/customers? tell it better|reviews|what.*say/i.test(t)) {
        return heads[i].closest('.shopify-section, section, [class*="section-"]') || heads[i];
      }
    }
    var slider = document.querySelector('[class*="testimonials-slider-wrapper"], [class*="testimonials-template"]');
    if (slider) return slider.closest('.shopify-section') || slider;
    return document.querySelector('[class*="jdgm-rev-widg"], [id*="judgeme_product_reviews"]');
  }

  function initRatingClickable() {
    var rating = document.querySelector('.product__rating-below-price .product-rating');
    if (!rating || rating.dataset.solveyClickable === '1') return;
    rating.dataset.solveyClickable = '1';
    rating.setAttribute('role', 'button');
    rating.setAttribute('tabindex', '0');
    rating.setAttribute('aria-label', 'Read customer reviews');

    var go = function (e) {
      var target = findReviewsTarget();
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: top, behavior: 'smooth' });
    };
    rating.addEventListener('click', go);
    rating.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') go(e);
    });
  }

  /* ---------- 4. Quantity inline (CSS does the work) ---------- */
  function initQuantityInline() {
    var group = document.querySelector('.product__controls-group-quantity');
    if (!group || group.dataset.solveyQtyInline === '1') return;
    group.dataset.solveyQtyInline = '1';
  }

  /* ---------- Run all init functions ---------- */
  var run = debounce(function () {
    if (IS_PROBIOTICS) {
      initPriceRatingInline();
      initRatingClickable();
    }
    initQuantityInline();
    if (MOBILE_MQ.matches) {
      initGalleryDots();
      initGallerySwipe();
    }
  }, DEBOUNCE);

  /* ---------- Idempotent observer attach ---------- */
  function attachObservers() {
    var headerInner = document.querySelector('.product__block--product-header-inner');
    if (headerInner && headerInner.dataset.solveyObserved !== '1') {
      headerInner.dataset.solveyObserved = '1';
      new MutationObserver(run).observe(headerInner, {
        childList: true,
        subtree: true
      });
    }
    var galleryContainer = document.querySelector('.product__media-container');
    if (galleryContainer && galleryContainer.dataset.solveyObserved !== '1') {
      galleryContainer.dataset.solveyObserved = '1';
      new MutationObserver(run).observe(galleryContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  /* ---------- Boot ---------- */
  function boot() {
    run();
    attachObservers();
  }

  /* ---------- Viewport breakpoint changes ---------- */
  var onMq = function () {
    if (!MOBILE_MQ.matches) {
      var stale = document.querySelector('.solvey-gallery-dots');
      if (stale) stale.remove();
      // Allow re-init on next mobile entry; touch listeners do nothing on desktop anyway
      var media = document.querySelector('.product__media');
      if (media) delete media.dataset.solveySwipe;
    }
    run();
  };
  if (MOBILE_MQ.addEventListener) MOBILE_MQ.addEventListener('change', onMq);
  else MOBILE_MQ.addListener(onMq);

  /* ---------- Shopify editor section/block reload ---------- */
  // After a section reload the previous header-inner / media-container nodes are detached.
  // Their dataset.solveyObserved flag dies with them, so attachObservers() will re-attach
  // to the new nodes without duplicating observers on the surviving ones.
  ['shopify:section:load', 'shopify:section:reload', 'shopify:block:select', 'shopify:block:deselect'].forEach(function (ev) {
    document.addEventListener(ev, function () {
      // Reset re-parent guard since header-inner may be a fresh node
      if (IS_PROBIOTICS) {
        var inner = document.querySelector('.product__block--product-header-inner');
        if (inner) delete inner.dataset.solveyHeaderInline;
      }
      boot();
    });
  });

  /* ---------- Initial boot ---------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
